import type { PaymentMethodError, PayMethodQuote, SwapCryptoQuote } from '@kano/types';
import { ModelView } from '@/types';

export class PayMethodQuoteModel extends ModelView<PayMethodQuote> {
    private readonly _error: string | null;
    private readonly _errorCode: string | null;

    constructor(item: PayMethodQuote, error: PaymentMethodError | null = null) {
        super(item);

        this._error = error?.error.message ?? null;
        this._errorCode = error?.error.code ?? null;
    }

    get id() {
        return this.item.id;
    }

    get name() {
        return this.item.name;
    }

    get amountFrom() {
        return this.item.amountFrom;
    }

    get amountTo() {
        return this.item.amountTo;
    }

    get amountToEquivalent() {
        return this.item.amountToEquivalent;
    }

    get amountFromEquivalent() {
        return this.item.amountFromEquivalent;
    }

    get fees() {
        return this.item.fees;
    }

    get feesInCrypto() {
        return this.item.feesInCrypto;
    }

    get exchangeRateCryptoToFiat() {
        return this.item.exchangeRateCryptoToFiat;
    }

    get commissions() {
        return this.item.commissions;
    }

    get expiresAt() {
        return this.item.expiresAt;
    }

    get error() {
        return this._error;
    }

    get errorCode() {
        return this._errorCode;
    }
}

export class SwapCryptoQuoteModel extends ModelView<SwapCryptoQuote> {
    get id() {
        return this.item.id;
    }

    get name() {
        return this.item.name;
    }

    get amountFrom() {
        return this.item.amountFrom;
    }

    get amountTo() {
        return this.item.amountTo;
    }

    get fees() {
        return this.item.fees;
    }

    get feesInCrypto() {
        return this.item.feesInCrypto;
    }

    get exchangeRateCryptoToFiat() {
        return this.item.exchangeRateCryptoToFiat;
    }

    get expiresAt() {
        return this.item.expiresAt;
    }

    get relationLink() {
        return this.item.link;
    }

    get exchangeRate() {
        return this.item.exchangeRate;
    }

    get error() {
        return this.item.payoutMethodErrors?.[0]?.error.message;
    }

    get errorCode() {
        return this.item.payoutMethodErrors?.[0]?.error.code;
    }
}
